import { Component, Input, OnInit, ViewChild, ElementRef} from '@angular/core';
import { CnsltnReqModel,  CnsltnQuotRouteModel, NodeType, ModeType, FareService} from '../../../../services/index';
import { FormControl } from '@angular/forms';
import { Country, Address, CountryService, City, Location, Port, Airport, PortService, AirPortService, CityService } from '../../../../services/index';
import { OceanLineService, AirLineService, OceanLine, AirLine } from '../../../../services/index';
import { dragula } from 'ng2-dragula'
import { DragulaService } from 'ng2-dragula/ng2-dragula';
import _ from 'lodash';
declare var $:any;


@Component({
    selector:'fare-rate-detail-route',
	templateUrl: 'fare-rate-detail-route.html',
	inputs: ['fareTypeNm', 'cnsltnReqAdrs', 'fareTypeCd', 'linerNm', 'modeNm'],
})


export class FareRateDetailRoute implements OnInit {
	private _cnsltnReq:CnsltnReqModel = new CnsltnReqModel();
	private linerNm:string;
	private modeNm:string;
	public cnsltnQuotRouteList:Array<CnsltnQuotRouteModel> = new Array();
	public cnsltnQuotRouteBasicList:Array<CnsltnQuotRouteModel>;
	
	private cnsltnQuotRouteMap:Map<number, CnsltnQuotRouteModel> = new Map<number, CnsltnQuotRouteModel>();

	private countries: Array<Country> = [];
	private ports: Array<Port> = [];
	private airports: Array<Airport> = [];

	private airLines: Array<AirLine> = [];
	private oceanLines: Array<OceanLine> = [];

	private _allList = null;
	@Input() set allList(allList:any){
		if(allList == null) return;
		this._allList = allList;

		this.countries = this._allList.countries;
		this.ports = this._allList.ports;
		this.airports = this._allList.airports;
		this.airLines = this._allList.airLines;
		this.oceanLines = this._allList.oceanLines;

		this.makeRouterList();
	}

	private _quotNo = null;
	@Input() set quotNo(quotNo:string){
		this._quotNo = quotNo;
	}

	get quotNo(){
		return this._quotNo;
	}


	transferData: any;
	@ViewChild('basicRoute') basicRouteRef: any;
	@ViewChild('saveRoute') saveRoute: any;
	constructor(
		private countryService:CountryService,
		private portService:PortService,
		private airportService:AirPortService,
		private dragulaService: DragulaService,
		private oceanLineService: OceanLineService,
		private airLineService: AirLineService,
		private cityService:CityService,
		private fareService:FareService
	){
		let that = this;
		dragulaService.removeModel.subscribe((args: any) => {
			let [bagName, el, target, source] = args;
			if(this.saveRoute.nativeElement === source && this.basicRouteRef.nativeElement === target){
				
			}
		});
		dragulaService.dropModel.subscribe((args: any) => {
			let [bagName, el, target, source] = args;

			if(this.saveRoute.nativeElement === source && this.basicRouteRef.nativeElement === target){
				let transferData:any = {
					taskId: el.dataset.id,
					oldLabelId: source.dataset.id,
					newLabelId: target.dataset.id,
					oldIndex: el.dataset.index
				}
				for(let i=0; i < this.cnsltnQuotRouteBasicList.length; i++){
					let basicRoute = this.cnsltnQuotRouteBasicList[i];
					if(transferData.taskId == basicRoute.typeCd){
						this.cnsltnQuotRouteBasicList.splice(i,1);
						this.basicRouteListSort();
						this.routeListSort();
						break;
					}
				}
			}

			if(this.saveRoute.nativeElement !== source && this.saveRoute.nativeElement === target){ 
				let transferData:any = {
					taskId: el.dataset.id,
					oldLabelId: source.dataset.id,
					newLabelId: target.dataset.id,
					oldIndex: el.dataset.index
				}
				
				let cnsltnQuotRoute:CnsltnQuotRouteModel = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
				cnsltnQuotRoute.typeCd = transferData.taskId ;
				this.cnsltnQuotRouteBasicList.push(cnsltnQuotRoute);
				this.routeListSort();
				this.basicRouteListSort();
				
			}else if(this.saveRoute.nativeElement === source && this.saveRoute.nativeElement === target){
				this.routeListSort();
			}
        });
	}

	routeListSort(){
		let polIndex = -1;
		let podIndex = -1;
		for(let i = 0; i < this.cnsltnQuotRouteList.length; i++){
			let cnsltnQuotRouteModel = this.cnsltnQuotRouteList[i];

			if(!cnsltnQuotRouteModel.linerNm && (cnsltnQuotRouteModel.typeCd == NodeType.PORT || cnsltnQuotRouteModel.typeCd == NodeType.AIRPORT)){
				cnsltnQuotRouteModel.linerNm = this.linerNm;
			}

			if(!cnsltnQuotRouteModel.modeNm){
				cnsltnQuotRouteModel.modeNm = this.modeNm;
			}

			cnsltnQuotRouteModel.airports = this.airports;
			cnsltnQuotRouteModel.countries = this.countries;
			cnsltnQuotRouteModel.ports = this.ports;
			cnsltnQuotRouteModel.airLines = this.airLines;
			cnsltnQuotRouteModel.oceanLines = this.oceanLines;
			cnsltnQuotRouteModel.seq = i;
			if(this._cnsltnReq.transTp == 1 && cnsltnQuotRouteModel.typeCd == NodeType.PORT){
				alert('AIR PORT만 입력 가능합니다.');
				this.cnsltnQuotRouteList.splice(i,1);
				i = 0;
				continue;
			}

			if(this._cnsltnReq.transTp == 0 && cnsltnQuotRouteModel.typeCd == NodeType.AIRPORT){
				alert('PORT만 입력 가능합니다.');
				this.cnsltnQuotRouteList.splice(i,1);
				i = 0;
				continue;
			}

			if(polIndex == -1 && (cnsltnQuotRouteModel.typeCd == NodeType.PORT || cnsltnQuotRouteModel.typeCd == NodeType.AIRPORT)){
				polIndex = i;
			}
			if(polIndex > -1 && (cnsltnQuotRouteModel.typeCd == NodeType.PORT || cnsltnQuotRouteModel.typeCd == NodeType.AIRPORT)){
				podIndex = i;
			}
			if(cnsltnQuotRouteModel.typeNm == 'POL' || cnsltnQuotRouteModel.typeNm == 'POD'){
				if(cnsltnQuotRouteModel.typeCd == NodeType.AIRPORT){
					cnsltnQuotRouteModel.typeNm = 'AIR PORT';
				}else{
					cnsltnQuotRouteModel.typeNm = 'PORT';
				}
			}
		}
		if(polIndex > -1){
			this.cnsltnQuotRouteList[polIndex].typeNm = 'POL';
		}
		if(podIndex > -1){
			this.cnsltnQuotRouteList[podIndex].typeNm = 'POD';
		}
	}

    @Input() set cnsltnReq(cnsltnReq:CnsltnReqModel){
        if(!cnsltnReq || !cnsltnReq.reqNo) return ;
		this._cnsltnReq = cnsltnReq;
		this.makeRouterList();
	}
	
	isMakeToRouteList(){
		if(!this._cnsltnReq || 
			!this.oceanLines || this.oceanLines.length == 0 || 
			!this.countries || this.countries.length == 0 || 
			!this.ports || this.ports.length == 0 || 
			!this.airports || this.airports.length == 0 || 
			!this.airLines || this.airLines.length == 0) return false;
		return true;
	}

    makeRouterList(){
		if(this._allList == null || !this._cnsltnReq.reqNo) return;

		var i = -1;
		var tempRouteList:Array<any> = new Array();
        if(this._cnsltnReq.orgTp == 1) tempRouteList.push(this.makeRouter(NodeType.ORIGIN, "DOOR", ++i));
		if(this._cnsltnReq.transTp == 1) {
			tempRouteList.push(this.makeRouter(NodeType.AIRPORT, "POL", ++i));
			tempRouteList.push(this.makeRouter(NodeType.AIRPORT, "POD", ++i));
		}else{
			tempRouteList.push(this.makeRouter(NodeType.PORT, "POL", ++i));
			tempRouteList.push(this.makeRouter(NodeType.PORT, "POD", ++i));
		} 
		if(this._cnsltnReq.desTp == 1) tempRouteList.push(this.makeRouter(NodeType.DESTINATION, "DOOR", ++i));

		if(this.quotNo == null) this.cnsltnQuotRouteList = tempRouteList;
    }

    makeRouter(nodeType:NodeType, typeNm:string, seq:number){
		let cnsltnQuotRoute:CnsltnQuotRouteModel = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
		cnsltnQuotRoute.location = new Location();
        cnsltnQuotRoute.typeCd = nodeType;
        cnsltnQuotRoute.seq = seq;
		cnsltnQuotRoute.typeNm = typeNm;

		// if(!this.airLines || this.airLines.length < 1){
		// 	this.airLineService.getAirLineList().subscribe((data:any)=>{
		// 		cnsltnQuotRoute.airLines = data;
		// 	});
		// }

		// if(!this.oceanLines || this.oceanLines.length < 1){
		// 	this.oceanLineService.getOceanLineList().subscribe((data:any)=>{
		// 		cnsltnQuotRoute.oceanLines = data; 
		// 	});
		// }

		let adrs = "";
		let locationId = 0;
		let cntryNm = "";
		let cntryCd = "";
		let latitude = 0;
		let longitude = 0;

		if((this._cnsltnReq.orgTp == 1 && typeNm.indexOf("POL") > -1) || (this._cnsltnReq.desTp == 1 && typeNm.indexOf("POD") > -1)){
			return cnsltnQuotRoute;
		}

		if(typeNm.indexOf("POL") > -1 || nodeType == NodeType.ORIGIN){
			adrs = this._cnsltnReq.orgAdrsPiece;
			locationId = this._cnsltnReq.orgLocationId;
			cntryNm = this._cnsltnReq.orgCntryNm;
			cntryCd = this._cnsltnReq.orgCntryCd;
			latitude = this._cnsltnReq.orgLatitude;
			longitude = this._cnsltnReq.orgLongitude;
		}else if(typeNm.indexOf("POD") > -1 || nodeType == NodeType.DESTINATION){
			adrs = this._cnsltnReq.desAdrsPiece;
			locationId = this._cnsltnReq.desLocationId;
			cntryNm = this._cnsltnReq.desCntryNm;
			cntryCd = this._cnsltnReq.desCntryCd;
			latitude = this._cnsltnReq.desLatitude;
			longitude = this._cnsltnReq.desLongitude;
		}

		cnsltnQuotRoute.location.locationId = locationId
		cnsltnQuotRoute.location.cntryNm = cntryNm
		cnsltnQuotRoute.longitude = longitude;
		cnsltnQuotRoute.latitude = latitude;
		cnsltnQuotRoute.cntryCd = cntryCd;


		//Air Port or Port
		if((this._cnsltnReq.orgTp == 0 && typeNm.indexOf("POL") > -1) || (this._cnsltnReq.desTp == 0 && typeNm.indexOf("POD") > -1)){
			if(location){
				let ports:any;
				if(nodeType == NodeType.PORT){
					ports = this.ports; 
				}else{
					ports = this.airports;
				}
				let filteredPorts = _.filter(ports, {'cntryCd' : cntryCd});
				for(let i=0; i<filteredPorts.length; i++){
					if(filteredPorts[i].locationId == locationId){
						cnsltnQuotRoute.location.name = filteredPorts[i].name;
						cnsltnQuotRoute.latitude = filteredPorts[i].latitude;
						cnsltnQuotRoute.longitude = filteredPorts[i].longitude;
						this.saveRouteListSort();
					} 
				}
			}
		}

		//Door Address
		if((nodeType == NodeType.ORIGIN && this._cnsltnReq.orgTp == 1) || (nodeType == NodeType.DESTINATION && this._cnsltnReq.desTp == 1)){
			
			cnsltnQuotRoute.locationAdrs = adrs;
			cnsltnQuotRoute.typeCd = NodeType.DOOR;

			if(location){
				this.cityService.getCities(cntryCd).subscribe(
					(cityList:Array<City>) => {
						for(let i=0; i<cityList.length; i++){
							if(cityList[i].locationId == locationId){
								cnsltnQuotRoute.location.name = cityList[i].name;
								this.saveRouteListSort();
								break;
							} 
						}
					},
					err => console.log("Error code: %s, URL: %s", err.status, err.url)
				);
			}
		}

		return cnsltnQuotRoute;
	}

    ngOnInit(){
		this.makeBasicRoute();
	}

	makeBasicRoute(){
		this.cnsltnQuotRouteBasicList = new Array<CnsltnQuotRouteModel>();
		let cnsltnQuotRoute:CnsltnQuotRouteModel = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
		cnsltnQuotRoute.typeCd = NodeType.PORT;
		cnsltnQuotRoute.typeNm = 'PORT';
		this.cnsltnQuotRouteBasicList.push(cnsltnQuotRoute);
		cnsltnQuotRoute = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
		cnsltnQuotRoute.typeCd = NodeType.RAIL;
		cnsltnQuotRoute.typeNm = 'RAIL';
		this.cnsltnQuotRouteBasicList.push(cnsltnQuotRoute);
		cnsltnQuotRoute = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
		cnsltnQuotRoute.typeCd = NodeType.AIRPORT;
		cnsltnQuotRoute.typeNm = 'AIR PORT';
		this.cnsltnQuotRouteBasicList.push(cnsltnQuotRoute);
		cnsltnQuotRoute = new CnsltnQuotRouteModel(this.countries, this.ports, this.airports, this.airLines, this.oceanLines);
		cnsltnQuotRoute.typeCd = NodeType.DOOR;
		cnsltnQuotRoute.typeNm = 'DOOR';
		this.cnsltnQuotRouteBasicList.push(cnsltnQuotRoute);

		this.basicRouteListSort();
	}

	basicRouteListSort(){
		this.cnsltnQuotRouteBasicList = _.sortBy(this.cnsltnQuotRouteBasicList,
				(cnsltnQuotRoute:CnsltnQuotRouteModel) => {
				return cnsltnQuotRoute.typeCd;
		});
	}
	saveRouteListSort(){
		this.cnsltnQuotRouteList = _.sortBy(this.cnsltnQuotRouteList,
			(cnsltnQuotRoute:CnsltnQuotRouteModel) => {
			  return cnsltnQuotRoute.seq;
		});
	}
	
	receivedRouteData(routeList:Array<CnsltnQuotRouteModel>){
		this.cnsltnQuotRouteList = null;
		this.cnsltnQuotRouteList = routeList;
		this.routeListSort();		
	}
}


// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/detail/fare-rate-detail-route.ts